import React from 'react'
import BaseLayout from './BaseLayout'
import useTitle from '../../hooks/title'
import { observer } from "mobx-react-lite"

import classes from './styles.module.scss'


const Copyrights = observer(() => {
    useTitle('Copyrights');
  return <BaseLayout>

      <div className={classes['head1']}>
            <h1>Copyright informations</h1>
        </div>
        
        <div className={classes['paragraph']}>
            <p>© Session Loops Inc. 2026 - All Rights Reserved</p>
            <p> No part of this website or any of its contents may be reproduced, copied, modified or adapted, without the prior written consent of the author, unless otherwise indicated for stand-alone materials.</p>
            <p> You may share this website by any of the following means:</p>

            <ol>
                <li>Using any of the share icons located on the SessionLoops.com website;</li>
                <li>Providing a back-link or the URL of the content you wish to disseminate; and</li>
                <li>You may quote extracts from the website with attribution to SessionLoops.com.</li>
            </ol>
        </div>
        
        <div className={classes['paragraph']}>
            <p> For any other mode of sharing, please contact us at support@sessionloops.com.<br/>
                Commercial use and distribution of the contents of the website is not allowed without express and prior written consent of the author.</p>
        </div>
  </BaseLayout>
})

export default Copyrights